import { RebrandTheme } from '../models/common.models';

const successPhoto = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/rebrand/thankyoucheck.png';
const logoUrl = 'https://ti2020-qa-storage.tolunastart.com/images/common/TS_Logo.svg';

const backArrow = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/arrow_back+-+material.png';
const BehavioralDataBg = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/BG+Image_Behavioral+Data.png';
const BrandedCommunitiesBg = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/BG+Image_Branded+Communities.png';
const LiveDiscussionsBg = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/BG+Image_Live+discussion.png';

export const reBrandTheme: RebrandTheme = {
    mainFontFamily: 'GreycliffCF-Bold',
    mainColor: '#003399',
    skeletonColor: '#F0F1F5',
    header: {
        logoImage: {
            width: '178px',
            height: '25px',
            paddingIsOnTop: '0 36px',
            padding: '0',
            imageUrl: logoUrl,
        },
        outlineColor: '#007FE64D',
        myProjects: {
            borderBottomColor: '#E40049',
            fontFamily: 'GreycliffCF',
        },
        createButton: {
            fontFamily: 'GreycliffCF',
            iconColor: '#E40049',
            color: '#60738F',
            colorHover: '#E40049',
            backgroundColor: 'transparent',
            backgroundColorHover: '#efefef',
            textTransform: 'uppercase',
            iconSize: '13px',
            header: {
                chooseFrom: {
                    fontFamily: 'GreycliffCF-Bold',
                },
                createCustomButton: {
                    fontFamily: 'GreycliffCF-Bold',
                    color: '#003399',
                    borderColor: '#003399',
                    backgroundColor: 'transparent',
                    colorHover: '#fff',
                    backgroundColorHover: '#003399',
                },
            },
            content: {
                categories: {
                    fontFamily: 'GreycliffCF-Medium',
                    color: '#60738F',
                    colorHover: '#E40049',
                    colorSelected: '#E40049',
                    backgroundColorHover: 'rgb(250, 250, 250)',
                    borderRadius: '6px',
                },
                items: {
                    backgroundColor: '#FAFAFA',
                    backgroundBorderRadius: '6px',
                    item: {
                        fontFamily: 'GreycliffCF-Bold',
                        color: '#003399',
                        borderHover: '2px solid #003399',
                        border: '2px solid transparent',
                        padding: '2px',
                    },
                },
                demoSection: {
                    sidebar: {
                        title: {
                            fontFamily: 'GreycliffCF-Light',
                            color: '#E40049',
                        },
                        description: {
                            fontFamily: 'GreycliffCF-Light',
                            color: '#003399',
                        },
                        images: {
                            arrow: backArrow,
                            9: BehavioralDataBg,
                            7: BrandedCommunitiesBg,
                            8: LiveDiscussionsBg,
                        },
                    },
                    demoForm: {
                        title: {
                            fontFamily: 'GreycliffCF-Light',
                            color: '#E40049',
                        },
                        button: {
                            fontFamily: 'GreycliffCF-Bold',
                            borderColor: '#003399',
                        },
                        label: {
                            color: '#003399',
                            fontFamily: 'GreycliffCF-Light',
                        },
                        inputField: {
                            fontFamily: 'GreycliffCF-Light',
                            border: '#003399',
                            onFocusBorder: '2px solid #003399',
                        },
                        success: {
                            color: '#003399',
                            fontFamily: 'GreycliffCF-Light',
                        },
                    },
                },
            },
        },
        createMenu: {
            actions: {
                fontFamily: 'GreycliffCF',
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '20px',
            },
            categoryRow: {
                fontFamily: 'GreycliffCF',
                fontSize: '14px',
                color: '#2E2F3C',
                fontWeight: 700,
                lineHeight: '24px',
            },
            solutionName: {
                fontFamily: 'GreycliffCF',
                fontSize: '14px',
                color: '#2E2F3C',
                fontWeight: 600,
                lineHeight: '20px',
            },
            solutionShortDescription: {
                fontFamily: 'GreycliffCF',
                fontSize: '13px',
                color: '#60616E',
                fontWeight: 500,
                lineHeight: '16px',
            },
        },
        userMenu: {
            fontFamily: 'GreycliffCF',
            iconColor: '#003399',
        },
    },
    footer: {
        contactUs: {
            title: {
                fontFamily: 'GreycliffCF-Bold',
                color: '#2D3643',
                borderTopColor: '#E40049',
            },
            button: {
                fontFamily: 'GreycliffCF-Bold',
                backgroundColor: '#003399',
                backgroundColorHover: '#00297A',
            },
            success: {
                image: successPhoto,
                thankYou: {
                    fontFamily: 'GreycliffCF-Light',
                    color: '#003399',
                },
                response: {
                    fontFamily: 'GreycliffCF-Regular',
                    color: '#60738F',
                },
            },
        },
        footerLeft: {
            colorHover: '#E40049',
        },
        rights: {
            fontFamily: 'GreycliffCF-Regular',
        },
        link: {
            fontFamily: 'GreycliffCF-Regular',
        },
    },
};
